import VenuesManagementPanel from '../components/VenuesManagementPanel';

const AllVenues = () => {
  return <VenuesManagementPanel />;
};

export default AllVenues;
